__turbopack_context__.v({
  "indicator": "ctfD6q_indicator",
  "indicatorDegraded": "ctfD6q_indicatorDegraded",
  "indicatorHealthy": "ctfD6q_indicatorHealthy",
  "indicatorOffline": "ctfD6q_indicatorOffline",
  "indicatorStarted": "ctfD6q_indicatorStarted",
  "indicatorUnhealthy": "ctfD6q_indicatorUnhealthy",
  "label": "ctfD6q_label",
  "root": "ctfD6q_root",
  "rootOffline": "ctfD6q_rootOffline",
});
